import { useState, useEffect, useCallback } from 'react';
import {
  listDocuments,
  listBatches,
  getBatch,
} from '../../../_services/documentsService';

export const useDocuments = (documentType = ['EVIDENCE'], questionType) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetch = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const result = await listDocuments({ documentType, questionType });
      setData(result);
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(documentType), questionType]);

  useEffect(() => { fetch(); }, [fetch]);
  return { data, setData, isLoading, error, refetch: fetch };
};

export const useDocumentsBatches = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetch = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const result = await listBatches();
      setData(result);
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => { fetch(); }, [fetch]);
  return { data, setData, isLoading, error, refetch: fetch };
};

export const useDocumentsBatch = (id) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetch = useCallback(async () => {
    if (!id) return;
    try {
      setIsLoading(true);
      setError(null);
      const result = await getBatch(id);
      setData(result);
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => { fetch(); }, [fetch]);
  return { data, isLoading, error, refetch: fetch };
};
